import * as React from "react";
import { forwardRef } from "react";
const SvgRemove = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 26, height: 26, viewBox: "0 0 26 26", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M17.5502 8.4502L8.4502 17.5502M17.5502 17.5502L8.4502 8.4502L17.5502 17.5502Z", stroke: "#BDBDBD", strokeWidth: 1.4, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgRemove);
export { ForwardRef as ReactComponent };
